import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'
import icon32 from '../icons/favicon-32x32.png'
import icon16 from '../icons/favicon-16x16.png'
import appleTouch from '../icons/apple-touch-icon.png'
import iconMask from '../icons/safari-pinned-tab.svg'


function SEO({ description, lang, meta, keywords, title, image, url }) {
  return (
    <StaticQuery
      query={detailsQuery}
      render={data => {
        const metaDescription =
          description || data.site.siteMetadata.description
        return (
          <Helmet
            htmlAttributes={{
              lang,
            }}
            title={title} 
            titleTemplate={`%s | ${data.site.siteMetadata.title}`}
            meta={[
              {
                name: `og:image`,
                content: image,
              },
              {
                name: `og:url`,
                content: url,
              },
              {
                name: `description`,
                content: metaDescription,
              },
              {
                property: `og:title`,
                content: title,
              },
              {
                property: `og:description`,
                content: metaDescription,
              },
              {
                property: `og:type`,
                content: `website`,
              },
              {
                name: `twitter:card`,
                content: `summary`,
              },
              {
                name: `twitter:creator`,
                content: data.site.siteMetadata.author,
              },
              {
                name: `twitter:title`,
                content: title,
              },
              {
                name: `twitter:description`,
                content: metaDescription,
              },
              {
                name: `msapplication-TileColor`,
                content: `#da532c`,
              },
              {
                name: `theme-color`,
                content: `#ffffff`,
              },
            ]
              .concat(
                keywords.length > 0
                  ? {
                      name: `keywords`,
                      content: keywords.join(`, `),
                    }
                  : []
              )
              .concat(meta)}

              link={[
                { rel: 'shortcut icon', type: 'image/png', href: `${icon32}`, sizes: '32x32' },
                { rel: 'shortcut icon', type: 'image/png', href: `${icon16}`, sizes: '16x16' },
                { rel: 'apple-touch-icon', type: 'image/png', href: `${appleTouch}`, sizes: '120x120' },
                { rel: 'mask-icon', href: `${iconMask}`, color: '#5bbad5' },
            ]}
          />
        )
      }}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  keywords: [],
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
  url: PropTypes.string,
}

export default SEO

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        description
        author
      }
    }
  }
`
